module.exports = __webpack_public_path__ + "static/01-6b19b69d5fa5189d3f4ced44944d398b.jpg";